import { UPDATE_LOAN_FILTER_FORM_DATA } from "../actions/loanFilterFormData";

const defaultState = { bank: { allValues: true } };

export default (state = defaultState, action) => {
  switch (action.type) {
    case UPDATE_LOAN_FILTER_FORM_DATA:
      return Object.assign({}, state, action.formData);
    default:
      return state;
  }
};
